import { useCallback, useState } from 'react';
import { createContextHardened } from 'src/Common/Helper/ContextHelper';

interface Context {
  isDrawerOpen: boolean;
  setDrawerOpen: (open: boolean) => void;
  toggleDrawer: () => void;
}

const [SettingsContext, useSettingsSection] = createContextHardened<Context>('Settings Section');
export { useSettingsSection };

interface Props {
  children: React.ReactNode;
}
export default function SettingsSectionProvider({ children }: Props): React.JSX.Element {
  const [isDrawerOpen, setDrawerOpen] = useState<boolean>(false);

  const toggleDrawer = useCallback(() => {
    setDrawerOpen(!isDrawerOpen);
  }, [isDrawerOpen]);

  return (
    <SettingsContext.Provider
      value={{
        isDrawerOpen,
        setDrawerOpen,
        toggleDrawer,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}
